export default __webpack_public_path__ + "static/media/cloud-connect.82303298.svg";